<template>
  <div class="contract-information-page" v-loading.fullscreen.lock="fullscreenLoading">
    <Title currentPageTitle="合同终止/作废流程"></Title>

    <!-- 申请信息 -->
    <div class="contract-base-box">
      <p class="contract-base-name">申请信息</p>
      <el-row :gutter="24">
        <el-col :span="12">
          <div class="contract-base-title"
            ><span class="fontC-red">*</span>关联合同：</div>
          <el-input
            v-model.trim="selectedContractName"
            placeholder="请选择"
            readonly
            @focus="openContractDialog"
            class="contract-base-content"
          ></el-input>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"
            ><span class="fontC-red">*</span>操作类型：</div>
          <el-radio-group v-model="applyForm.operationType" class="contract-base-content" @change="handleOperationTypeChange"
            >
            <el-radio label="1">合同终止</el-radio>
            <el-radio label="2">合同作废</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-row :gutter="24" v-if="applyForm.operationType == '1'">
        <el-col :span="12">
          <div class="contract-base-title"
            ><span class="fontC-red">*</span>终止日期：</div>
          <el-date-picker
            class="contract-base-content"
            v-model="applyForm.endTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24" class="reason-row"
          ><div class="contract-base-title"
            ><span class="fontC-red">*</span>{{ reasonLabel }}：</div>
          <el-input
            v-model.trim="applyForm.endReason"
            type="textarea"
            :rows="3"
            :maxlength="300"
            show-word-limit
            class="contract-base-content reason-content"
            :placeholder="'请输入' + reasonLabel"
            resize="none"
          ></el-input>
        </el-col>
      </el-row>
    </div>

    <!-- 合同信息 -->
    <div class="contract-base-box">
      <p class="contract-base-name">合同信息</p>
      <el-row :gutter="24">
        <el-col :span="12">
          <div class="contract-base-title">甲方名称：</div>
          <div class="contract-base-content">{{ contractDetail.tenantName || '-' }}</div>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title">乙方名称：</div>
          <div class="contract-base-content">{{ contractDetail.serviceTenantName || '-' }}</div>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title">公司类型：</div>
          <div class="contract-base-content">{{ contractDetail.enterpriseCate | commonFilterName('平台企业类型') }}</div>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title">合同类型：</div>
          <div class="contract-base-content">{{ contractDetail.contractType | commonFilterName('合同类型') }}</div>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title">业务类型：</div>
          <div class="contract-base-content">{{ contractDetail.contractContentType == '1' ? '业务收入' : '业务支出' }}</div>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title">业务类型内容：</div>
          <div class="contract-base-content" v-if="contractDetail.contractContentType == '1'">{{ contractDetail.contractContent | commonFilterName('业务收入类型') }}</div>
          <div class="contract-base-content" v-else>{{ contractDetail.contractContent | commonFilterName('业务支出类型') }}</div>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title">项目经理：</div>
          <div class="contract-base-content">{{ contractDetail.projectManagerName || '-' }}</div>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title">合同金额(元)：</div>
          <div class="contract-base-content">{{ contractDetail.contractMoney | numDigit }}</div>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title">发票方式：</div>
          <div class="contract-base-content">{{ contractDetail.invoiceMode || '-' }}</div>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title">结算依据：</div>
          <div class="contract-base-content">{{ contractDetail.balanceBasis || '-' }}</div>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title">维保条件：</div>
          <div class="contract-base-content">{{ contractDetail.maintainCondition | commonFilterName('维保条件') }}</div>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title">任务价格是否含税：</div>
          <div class="contract-base-content">{{ contractDetail.isContainTax | getVisible }}</div>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title">是否垫资：</div>
          <div class="contract-base-content">{{ contractDetail.isAdvanceMoney | getVisible }}</div>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title">是否补充协议：</div>
          <div class="contract-base-content">{{ contractDetail.isSupplementAgreement | getVisible }}</div>
        </el-col>
      </el-row>
    </div>

    <!-- 合同附件 -->
    <div class="contract-base-box">
      <p class="contract-base-name">合同附件</p>
      <div class="contract-apply-file">
        <span>合同附件：</span>
        <div>
          <div v-for="(item, index) in fileList" :key="index">
            <div class="contract-file-inform">
              <img
                width="32"
                height="32"
                class="mr10"
                :src="item.type == 'word' ? require('../../assets/images/word_icon.png') : require('../../assets/images/pdf_icon.png')"
                alt=""
              />
              <span>{{ item.name }}</span>
              <span class="fontC-4fa1a4 c-pointer ml10" @click="toSee(item)">查看详情</span>
              <a
                :href="item.path + '?response-content-type=application/octet-stream'"
                style="text-decoration: none; cursor: pointer; color: #4fa1a4"
                download="FileName"
                class="fontC-4fa1a4 c-pointer ml10"
                >下载</a
              >
            </div>
          </div>
        </div>
      </div>
      <el-row :gutter="24">
        <el-col :span="24">
          <span class="contract-base-title">合同重点内容说明：</span>
          <div class="contract-base-content">{{ contractDetail.importantContent || '-' }}</div>
        </el-col>
      </el-row>
    </div>

    <!-- 产品信息 -->
    <div class="contract-base-box">
      <p class="contract-base-name">产品信息</p>
      <el-row :gutter="24" class="mb10">
        <el-col :span="24">
          <span class="contract-base-title">产品名称：</span>
          <div class="contract-base-content">{{ getProductName(contractDetail.contractProductList) }}</div>
        </el-col>
      </el-row>
    </div>

    <!-- 付款方式 -->
    <div class="contract-base-box">
      <p class="contract-base-name">付款方式</p>
      <el-row :gutter="24" class="mb10">
        <el-col :span="12">
          <span class="contract-base-title">付款方式：</span>
          <div class="contract-base-content">{{ contractDetail.payType | commonFilterName('付款方式') }}</div>
        </el-col>
      </el-row>
      <el-row
        :gutter="24"
        class="mb10"
        v-if="contractDetail.payType !== '1'"
        v-for="(item, index) in payTypeJsonList"
        :key="index"
      >
        <el-col :span="12">
          <span class="contract-base-title">回款方式：</span>
          <div class="contract-base-content" v-if="contractDetail.payType == '4'">{{ item.selectType | commonFilterName('费用类型') }}</div>
          <div class="contract-base-content" v-if="contractDetail.payType == '2'">{{ item.selectType | commonFilterName('季度选项') }}</div>
          <div class="contract-base-content" v-if="contractDetail.payType == '3'">{{ item.selectType | commonFilterName('年度选项') }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">{{ contractDetail.payType !== '4' ? '回款金额(元)' : '回款比例(%)' }}：</span>
          <div class="contract-base-content">{{ item.selectValue }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="mb10" v-if="contractDetail.payType == '1'">
        <el-col :span="12">
          <span class="contract-base-title">收费比例(%)：</span>
          <div class="contract-base-content">{{ chargeRate }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">下发扣除税点(%)：</span>
          <div class="contract-base-content">{{ sendTaxDeduction }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">是否内扣：</span>
          <div class="contract-base-content">{{ contractDetail.isInsideDeduction | getVisible }}</div>
        </el-col>
      </el-row>
    </div>

    <!-- 银行信息 -->
    <div class="contract-base-box">
      <p class="contract-base-name">银行信息</p>
      <el-row :gutter="24" class="mb10" v-for="(item, index) in contractDetail.contractBankList" :key="index">
        <el-col :span="12">
          <span class="contract-base-title">开户银行：</span>
          <div class="contract-base-content">{{ item.bankName || '-' }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">开户账号：</span>
          <div class="contract-base-content">{{ item.bankAccount || '-' }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">开户行号：</span>
          <div class="contract-base-content">{{ item.bankNo || '-' }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">税号：</span>
          <div class="contract-base-content">{{ item.bankTaxNo || '-' }}</div>
        </el-col>
      </el-row>
    </div>

    <!-- 签约任务 -->
    <div class="contract-base-box" v-show="contractDetail.contractTaskDetailList && contractDetail.contractTaskDetailList.length">
      <p class="contract-base-name">签约任务</p>
      <div class="content-main-box" style="height: auto">
        <el-table border stripe :data="contractDetail.contractTaskDetailList">
          <el-table-column :resizable="false" show-overflow-tooltip label="任务名称" width="180" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.oldTaskContentName || '-' }}</template>
          </el-table-column>
          <el-table-column :resizable="false" label="项目任务名称" width="180" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.taskContentName || '-' }}</template>
          </el-table-column>
          <el-table-column :resizable="false" show-overflow-tooltip label="任务价格(元)" width="160" header-align="center" align="right">
            <template slot-scope="scope">
              <div v-if="scope.row.priceType == 2">{{ scope.row.taskPrice | numDigit }} - {{ scope.row.maxTaskPrice | numDigit }}</div>
              <div v-if="scope.row.priceType == 1">{{ scope.row.taskPrice | numDigit }}</div>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" show-overflow-tooltip label="备注" width="100" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.taskDescription || '-' }}</template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 流程 -->
    <div style="padding-left: 16px; background: #fff; margin-top: 4px">
      <iframe v-show="iframeSh" :src="srcs" class="iframe-sty"></iframe>
    </div>

    <!-- 提交 -->
    <div class="submit-btn-box submit_btn_wrap">
      <el-button type="borderBlack" size="small" @click="$router.go(-1)">取消</el-button>
      <el-button type="borderGreen" size="small" @click="saveReq(0)">保存</el-button>
      <el-button type="importNew" size="small" @click="saveReq(1)">提交申请</el-button>
    </div>

    <!-- 选择关联合同弹框 -->
    <ContractSelectDialog
      :visible.sync="contractDialogVisible"
      :selectedGuid="applyForm.contractGuid"
      @select="onContractSelect"
    />
  </div>
</template>

<script>
import { bpmnroute } from '@/api/apiRoute';
import Title from '@/components/title/title.vue';
import ContractSelectDialog from './components/ContractSelectDialog.vue';
import {
  saveContractOperation,
  updateContractOperation,
  getContractOperationDetail,
} from '@/api/contractOperation.js';
export default {
  components: {
    Title,
    ContractSelectDialog,
  },
  data() {
    return {
      flowType: '00044',
      fullscreenLoading: false,
      iframeSh: false,
      srcs: '',
      // 申请信息
      applyForm: {
        contractGuid: null,
        operationType: null,
        endTime: null,
        endReason: null,
        approveState: null,
        approveGuid: null,
      },
      selectedContractName: '',
      // 弹框
      contractDialogVisible: false,
      // 合同信息
      contractDetail: {
        contractBankList: [],
        contractTaskDetailList: [],
        contractProductList: [],
      },
      fileList: [],
      payTypeJsonList: [],
    };
  },
  computed: {
    reasonLabel() {
      return this.applyForm.operationType == '2' ? '作废原因' : '终止原因';
    },
    chargeRate() {
      if (!this.contractDetail.chargeRate) {
        return '-';
      }
      return this.$options.filters.numDigit(this.contractDetail.chargeRate);
    },
    sendTaxDeduction() {
      if (!this.contractDetail.sendTaxDeduction) {
        return '-';
      }
      return this.$options.filters.numDigit(this.contractDetail.sendTaxDeduction);
    },
  },
  created() {
    this.getFlowGuid();
    if (this.$route.query.guid) {
      this.getPageDetail();
    }
  },
  methods: {
    // 查看附件
    toSee(item) {
      let path = item.path;
      if (path.indexOf('.pdf') > -1 || path.indexOf('.PDF') > -1) {
        window.open(path);
      } else {
        window.open('https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(path));
      }
    },
    getProductName(list) {
      let nameList = [];
      if (list && list.length > 0) {
        list.forEach((i) => {
          nameList.push(i.productName);
        });
      }
      return nameList.join(' , ') || '-';
    },
    // 打开选择合同弹框
    openContractDialog() {
      this.contractDialogVisible = true;
    },
    // 操作类型切换
    handleOperationTypeChange(val) {
      if (val == '2') {
        this.applyForm.endTime = null;
      }
    },
    // 选择合同后回填
    async onContractSelect(row) {
      if (!row || !row.guid) return;
      this.fullscreenLoading = true;
      const { data } = await this.api.get(
        `/${serverConfig.msCustomerService}/contract/detail?guid=${row.guid}`
      );
      this.fullscreenLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.applyForm.contractGuid = row.guid;
      this.setOriginalContract(data.data);
    },
    // 回填合同信息
    setOriginalContract(data) {
      this.selectedContractName = data.contractName || '';
      this.contractDetail = {
        ...this.contractDetail,
        ...data,
        contractBankList: data.contractBankList || [],
        contractTaskDetailList: data.contractTaskDetailList || [],
        contractProductList: data.contractProductList || [],
      };
      if (this.contractDetail.payType !== '1' && this.contractDetail.payTypeJson) {
        this.payTypeJsonList = JSON.parse(this.contractDetail.payTypeJson);
      } else {
        this.payTypeJsonList = [];
      }
      if (this.contractDetail.contractUrl) {
        this.fileList = JSON.parse(this.contractDetail.contractUrl);
        this.fileList.forEach((i) => {
          i.type = i.path && (i.path.indexOf('.pdf') > -1 || i.path.indexOf('.PDF') > -1) ? 'pdf' : 'word';
        });
      } else {
        this.fileList = [];
      }
    },
    // 获取详情（编辑/重新提交）
    async getPageDetail() {
      this.fullscreenLoading = true;
      const { data } = await getContractOperationDetail(this.$route.query.guid);
      this.fullscreenLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      let detail = data.data;
      this.applyForm = {
        ...detail,
        endTime: detail.endTime ? this.$moment(detail.endTime).format('YYYY-MM-DD') : null,
      };
      this.selectedContractName = detail.contractDetail ? detail.contractDetail.contractName || '' : '';
      this.setOriginalContract(detail.contractDetail || {});
    },
    // 获取流程Guid
    async getFlowGuid() {
      let userInfo = JSON.parse(localStorage.userInfo);
      let req = {
        tenantGuid: localStorage.guid,
        flowType: this.flowType,
        staffGuid: userInfo.staffGuid,
      };
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/work-flow/data/get-camunda-deployment-id`,
        req
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      if (data.data) {
        this.iframeSh = true;
        this.srcs = bpmnroute + '/iframeBpmn?camundaDeploymentId=' + data.data + '&token=' + localStorage.token;
      } else {
        this.$message.error(messageConfig.FLOW_NO_ID);
      }
    },
    // 表单校验
    checkForm() {
      if (!this.applyForm.contractGuid) {
        this.$message.error('关联合同不能为空');
        return false;
      }
      if (!this.applyForm.operationType) {
        this.$message.error('操作类型不能为空');
        return false;
      }
      if (this.applyForm.operationType == '1' && !this.applyForm.endTime) {
        this.$message.error('终止日期不能为空');
        return false;
      }
      if (!this.applyForm.endReason) {
        this.$message.error(this.reasonLabel + '不能为空');
        return false;
      }
      return true;
    },
    // 提交申请 type为1时提交0保存
    async saveReq(type) {
      if (!this.checkForm()) {
        return;
      }
      let userinfo = JSON.parse(localStorage.userInfo);
      let isEdit = this.$route.query.toType == 1;
      let isReSubmit = this.$route.query.toType == 3;
      let form = {
        guid: isEdit ? this.$route.query.guid : null,
        contractGuid: this.applyForm.contractGuid,
        staffGuid: userinfo.staffGuid,
        staffName: userinfo.staffName,
        operationType: this.applyForm.operationType,
        approveState: this.applyForm.approveState,
        approveGuid: this.applyForm.approveGuid,
        endTime: this.applyForm.endTime
          ? this.$moment(this.applyForm.endTime).format('YYYY-MM-DD HH:mm:ss')
          : null,
        endReason: this.applyForm.endReason,
        userTenantGuid: localStorage.guid,
        isDraft: type == 1 ? 'N' : 'Y',
        isApprove: type == 1 ? 'Y' : 'N',
        discardContractOperationGuid: isReSubmit ? this.$route.query.guid : null,
      };
      // 重新提交时点击保存，不需要传 approveGuid
      if (isReSubmit && type == 0) {
        form.approveGuid = null;
      }
      let url = isEdit ? updateContractOperation : saveContractOperation;
      this.fullscreenLoading = true;
      const { data } = await url(form);
      this.fullscreenLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.$message({
        message: '提交成功',
        type: 'success',
      });
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.contract-information-page {
  overflow: auto;
}
.contract-base-box {
  padding: 20px 16px;
  margin-top: 4px;
  background: #fff;
}
.contract-base-name {
  font-size: 16px;
  color: #212121;
  text-align: left;
  margin: 8px 0 20px 0;
}
.contract-base-box .el-col-12,
.contract-base-box .el-col-24 {
  min-height: 37px;
  display: flex;
  margin-bottom: 8px;
  padding-right: 20px;
  box-sizing: border-box;
}
.contract-base-title {
  flex-shrink: 0;
  width: 145px;
  line-height: 36px;
  text-align: right;
  font-size: 14px;
}
.contract-base-content {
  width: 314px;
  text-align: left;
  line-height: 36px;
}
/deep/ .el-radio-group {
  padding-top: 5px !important;
}
/deep/ .el-date-editor {
  width: 314px !important;
}
.content-main-box {
  height: 100%;
}
.contract-apply-file {
  display: flex;
  font-size: 14px;
  color: #666666;
  padding: 0 16px;
  box-sizing: border-box;
  line-height: 32px;
  margin-bottom: 20px;
}
.contract-file-inform {
  display: flex;
  align-items: center;
}
.iframe-sty {
  width: 100%;
  height: 500px;
  border: none;
}
.submit-btn-box {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  border-top: 1px solid #d9d9d9;
  background: #fff;
}
/deep/ .el-textarea {
  width: 314px;
}
/deep/ .reason-content.el-textarea {
  width: 70%;
}
/deep/ .el-textarea__inner {
  min-height: 80px !important;
}
</style>
